//import { UserDocument } from '@hooks/use-ocr.hooks'

import { useEffect, useRef } from 'react'
import InputText from '../input-text/input-text.component'
//import './input-upload.style.scss'
import clsx from 'clsx'
import { log } from '@utils/debug'
import type { UserDocument } from '@hooks/type-ds'
import { useUpload, type UploadError } from '@ui/richiesta/pages/components/use-upload.hook'

const EXT_ALLOWED = ['.jpg', '.jpeg', '.png', '.tiff', '.heic', '.heif', '.pdf']

type FileComponentProps = {
	fileName: string
	removeFile: (name: string) => void
}

const File: React.FC<FileComponentProps> = ({ fileName, removeFile }) => {
	return (
		<div className={'carta-id__file'}>
			<p className={'carta-id__file--name'}>{fileName}</p>
			<p
				className={'carta-id__file--remove'}
				onClick={() => removeFile(fileName)}
			>
				x
			</p>
		</div>
	)
}

type UploadStatus = {
	status: null | boolean
	isFilled: boolean
	shouldUpload: boolean
	id: UserDocument
	hasBeenUploaded: boolean
}

type InputUploadProps = {
	id: UserDocument
	maxDocs: number
	minDocs: number
	title: string
	onError: (error: UploadError) => void
	onUpload: (status: UploadStatus) => void
	areDocsQueued?: (status: boolean) => void
	shouldUpload: boolean
}

export const InputUpload: React.FC<InputUploadProps> = ({
	id,
	maxDocs,
	minDocs,
	title,
	onError,
	onUpload,
	shouldUpload,
	areDocsQueued,
}) => {
	const { files, updateFiles, removeFile, showLoader, hasError, uploadFiles } =
		useUpload(id, maxDocs, minDocs, onUpload)

	useEffect(() => {
		if (hasError.title !== 'NONE') {
			onError(hasError)
		}
	}, [hasError])

	useEffect(() => {
		if (shouldUpload && files.length >= minDocs) {
			uploadFiles()
		}
	}, [shouldUpload])

	useEffect(() => {
		log('queued', files.length >= minDocs)
		areDocsQueued?.(files.length >= minDocs)
	}, [files])

	const inputRef = useRef<HTMLInputElement>(null)

	return (
		<div
			className={clsx('upload-input', {
				'upload-input--padding': files.length === 0,
			})}
		>
			<InputText
				label={title}
				type={'file'}
				ref={inputRef}
				buttonLabel={'Allega'}
				onButtonClick={() => {
					inputRef.current?.click()
				}}
				className={'carta-id__upload'}
				onChange={(e) => updateFiles(e.target.files)}
				multiple
				accept={EXT_ALLOWED.join(',')}
			/>
			<div className={'carta-id__container--list'}>
				{!showLoader &&
					files?.map((file) => (
						<File fileName={file.name} removeFile={removeFile} />
					))}
			</div>
		</div>
	)
}
